// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Mute_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M5.055 3.246a.75.75 0 1 0-1.11 1.008L6.895 7.5H3A1.5 1.5 0 0 0 1.5 9v6A1.5 1.5 0 0 0 3 16.5h4.242l6.548 5.092A.75.75 0 0 0 15 21v-4.585l3.945 4.34a.75.75 0 1 0 1.11-1.01ZM3 9h3.75v6H3Zm10.5 10.466-5.25-4.083V8.99l5.25 5.775Zm3.938-5.978a2.25 2.25 0 0 0 0-2.974.75.75 0 1 1 1.125-.99 3.75 3.75 0 0 1 0 4.957.75.75 0 0 1-1.125-.993ZM9.923 6.363a.75.75 0 0 1 .13-1.053l3.737-2.906A.75.75 0 0 1 15 3v7.015a.75.75 0 0 1-1.5 0V4.534l-2.526 1.968a.75.75 0 0 1-1.052-.135ZM23.25 12a7.5 7.5 0 0 1-1.91 5 .75.75 0 0 1-1.117-1 6 6 0 0 0 0-8 .75.75 0 1 1 1.117-1 7.48 7.48 0 0 1 1.91 5Z',
  viewBox: '0 0 24 24',
  glyph: 'Mute_Stroke2_Corner0_Rounded',
})
